import { createApp } from 'vue';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css';
import App from './App.vue';
import { i18n } from './i18n';
import router from './router';
import { pinia } from './stores';
import './main.scss';

const app = createApp(App);

app.use(pinia);
app.use(i18n);
app.use(router);

router.isReady().then(() => {
  app.mount('#app');
  document.documentElement.dataset.prerenderReady = 'true';
  document.dispatchEvent(new Event('prerender-ready'));
});
